// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Folder20 from './Folder20.tsx';
import Folder20Filled from './Folder20Filled.tsx';
import Folder24 from './Folder24.tsx';
import Folder24Filled from './Folder24Filled.tsx';
import Folder40 from './Folder40.tsx';
import Folder40Filled from './Folder40Filled.tsx';
import Folder48 from './Folder48.tsx';
import Folder48Filled from './Folder48Filled.tsx';

type FolderProps = {
    variation: '20' | '20Filled' | '24' | '24Filled' | '40' | '40Filled' | '48' | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Folder20,
    Folder20Filled,
    Folder24,
    Folder24Filled,
    Folder40,
    Folder40Filled,
    Folder48,
    Folder48Filled,
};

const Folder: FC<FolderProps> = ({ variation, ...props }) => {
    const variationKey = `Folder${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Folder" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Folder;
